













































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import SkillDto from '@/models/Skills/SkillDto';
import UpdateSkillRequest from '@/models/Skills/UpdateSkillRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'SkillEdit'
})
export default class extends GiganautVueDialog {
 
  public entity = new SkillDto

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(AgencySettingsModule.currentSkill));
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
        if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateSkillRequest()
    request.updatedAt = this.entity.updatedAt;
    request.name = this.entity.name;
    await AgencySettingsModule.editSkill(request)
    this.dialog = false;
  }
}
